var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flag",class:{ close: _vm.toggleOpen && !_vm.isOpen },on:{"click":_vm.goHome}},[(_vm.logo)?[_c('img',{attrs:{"src":_vm.logo,"alt":_vm.$t('nav.platform_name'),"title":_vm.$t('nav.platform_name')}})]:[_c('span',{staticClass:"omit-1"},[_vm._v(" "+_vm._s(_vm.$t('nav.platform_name'))+" ")])]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }